import { render, staticRenderFns } from "./quick-alarm-actions.vue?vue&type=template&id=72e96b5b&"
import script from "./quick-alarm-actions.vue?vue&type=script&lang=js&"
export * from "./quick-alarm-actions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports